import React from 'react';
export default function announcePageTitle(title) {
    const el = document.getElementById('page-title-confirmation');
    el === null || el === void 0 ? void 0 : el.dispatchEvent(new window.CustomEvent('page-title', {
        detail: title
    }));
}
export function PageTitleConfirmation() {
    const [docTitle, setDocTitle] = React.useState('');
    const ref = React.useRef(null);
    React.useEffect(() => {
        const el = ref.current;
        const listener = ((e) => {
            setDocTitle(e.detail);
        });
        el.addEventListener('page-title', listener);
        return () => el.removeEventListener('page-title', listener);
    }, []);
    return (React.createElement("div", { id: "page-title-confirmation", ref: ref, className: "sr-only", "aria-live": "polite" }, `Loaded page "${docTitle}"`));
}
